import {
  __esm,
  __spreadValues
} from "./chunk-ZU6LNBSF.mjs";

// src/icons/ChatSuccessOutline.tsx
import React from "react";
var SvgChatSuccessOutline, ChatSuccessOutline_default;
var init_ChatSuccessOutline = __esm({
  "src/icons/ChatSuccessOutline.tsx"() {
    SvgChatSuccessOutline = (props) => /* @__PURE__ */ React.createElement(
      "svg",
      __spreadValues({
        xmlns: "http://www.w3.org/2000/svg",
        width: 24,
        height: 24,
        fill: "none",
        viewBox: "0 0 24 24"
      }, props),
      /* @__PURE__ */ React.createElement(
        "path",
        {
          fill: "currentColor",
          d: "M6.45455 19L2 22.5V4C2 3.44772 2.44772 3 3 3H21C21.5523 3 22 3.44772 22 4V18C22 18.5523 21.5523 19 21 19H6.45455ZM5.76282 17H20V5H4V18.3851L5.76282 17ZM11.2929 12.1213L15.5355 7.87868L16.9497 9.29289L11.2929 14.9497L7.40381 11.0607L8.81802 9.64645L11.2929 12.1213Z"
        }
      )
    );
    ChatSuccessOutline_default = SvgChatSuccessOutline;
  }
});

export {
  ChatSuccessOutline_default,
  init_ChatSuccessOutline
};
